import { render, staticRenderFns } from "./AfterOrderDetail.vue?vue&type=template&id=7c2c19cd&scoped=true"
import script from "./AfterOrderDetail.vue?vue&type=script&lang=js"
export * from "./AfterOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./AfterOrderDetail.vue?vue&type=style&index=0&id=7c2c19cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2c19cd",
  null
  
)

export default component.exports